import React, { useCallback, useEffect, useRef, useState } from "react";
import Avatar from "../../images/Avatar.png";
import BuyBoxBtn from "../CommonFields/BuyBoxBtn";
import Coin from "../../images/coin.png";
import { avatarList } from "../../api/coinStore.api";
import { url } from "../../config/url";
import ListLoader from "../Common/ListLoader";
import { t } from "i18next";
const Avatars = ({
  isReedemPopup,
  setIsReedemPopup,
  reedemItem,
  setReedemItem,
  isReward,
  setIsReward,
}) => {
  const [productList, setProductList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isPremiumUser, setIsPremiumUser] = useState(false);

  useEffect(() => {
    var isPremium = localStorage?.getItem('premiumUser') || false
    setIsPremiumUser(isPremium == true || isPremium == "true" ? true : false)
  }, [])

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  const loadMore = async () => {
    fetchBundles();
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchBundles = async () => {
    setLoading(true);
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "order",
          sortDirection: "desc",
        },
      };

      const res = await avatarList(data);
      setLoading(false);
      if (res?.success && res?.data) {
        let list = [];
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] };
            obj.index = i + 1;
            list.push(obj);
          }
        }

        if (currentPage == 1) {
          setProductList(list);
        } else {
          setProductList([...productList, ...list]);
        }
        setTotalPages(res?.totalPages);
      } else {
        setProductList([]);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const verifyAccount = (reward) => {
    setIsReedemPopup(true);
    setIsReward(false);
    setReedemItem(reward);
  };

  return (
    <div className="avatars">
      {productList.length > 0
        ? productList?.map((item, index) => {
            return (
              <div>
                {item?.name && item?.list?.length > 0 && (
                  <div
                    className="mt-3"
                    key={index}
                    ref={
                      productList?.length === index + 1
                        ? lastPostElementRef
                        : null
                    }
                  >
                    <h6 className="text-center">{item?.name}</h6>
                    <div className="avatar avatar-1 bundle-avatar buy-avatar scroll-none">
                      {item?.list?.map((itemAvatar, index) => {
                        itemAvatar.currency = item?.currency;
                        return (
                          <div className={`avatar-box avatar-box-1`}>
                            <div className="inner">
                              <div className="half-circle"></div>
                              <div className="avatar-image">
                                <img
                                  src={
                                    url?.IMAGE_URL + itemAvatar?.img?.default
                                  }
                                  alt={itemAvatar?.name}
                                />
                                <div className="d-flex bundle-text justify-content-center mt-2">
                                  <span>
                                    {itemAvatar?.name?.length > 10 ? (
                                      <marquee>
                                        {itemAvatar?.name}
                                      </marquee>
                                    ) : (
                                      itemAvatar?.name
                                    )}
                                  </span>
                                  {/* <span className="f-14">
                                    {itemAvatar?.name}
                                  </span> */}
                                </div>
                              </div>
                            </div>
                            {!itemAvatar?.isPurchase && !isPremiumUser ? (
                              <div
                                className="buy-box "
                                onClick={() => verifyAccount(itemAvatar)}
                              >
                                <div class="buy-box-back-card">
                                  <span className="f-12">
                                    {t("rewards-store.redeem_for")}
                                  </span>
                                  <span className="f-18 f-bold">
                                    {itemAvatar?.coinAmount + " "}
                                    <span>
                                      {item?.currency?.code === "INR" ? (
                                        item?.currency?.symbol
                                      ) : (
                                        <img
                                          className="rewardstore-img-icon-size"
                                          src={
                                            url?.IMAGE_URL +
                                            item?.currency?.img?.default
                                          }
                                          alt={itemAvatar?.name}
                                        />
                                      )}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            ) : itemAvatar?.isPurchase ? (
                              <div className="buy-box ">
                                <div class="buy-box-back-card">
                                  <span className="f-18 f-bold">bought</span>
                                </div>
                              </div>
                            ) : isPremiumUser ? (
                              <div className="buy-box ">
                                <div class="buy-box-back-card" style={{width: '100%'}}>
                                  <span className="f-18 f-bold">unlocked</span>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="buy-box "
                                onClick={() => verifyAccount(itemAvatar)}
                              >
                                <div class="buy-box-back-card">
                                  <span className="f-12">
                                    {t("rewards-store.redeem_for")}
                                  </span>
                                  <span className="f-18 f-bold">
                                    {itemAvatar?.coinAmount + " "}
                                    <span>
                                      {item?.currency?.code === "INR" ? (
                                        item?.currency?.symbol
                                      ) : (
                                        <img
                                          className="rewardstore-img-icon-size"
                                          src={
                                            url?.IMAGE_URL +
                                            item?.currency?.img?.default
                                          }
                                          alt={itemAvatar?.name}
                                        />
                                      )}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })
        : !loading && <div className='no-record-found-center' style={{ width: "100%", height: "50vh" }}>
          <span className="text-center">no data found</span>
        </div>}
      {loading && (
        <div className="w-100 d-flex justify-content-center">
          {" "}
          <ListLoader />
        </div>
      )}
    </div>
  );
};

export default Avatars;
